import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@fontsource-variable/dm-sans';
import './styles/index.css';
import { App } from './App';
import { ScenarioProvider } from './state/scenario';
import { ApiError } from './lib/api';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './features/auth/AuthProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Retry transient failures only; a 4xx means the input is wrong and retrying will not help.
      retry: (count, error) => count < 2 && error instanceof ApiError && (error.isNetwork || error.status >= 500),
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ScenarioProvider>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </ScenarioProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
